import React, { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getVideo } from './../../s3Func/s3Download';
import './PracticeSituation.css';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const PracticeSituation = (props) => {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practice, setPractice] = useState(false);
  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const animalAudioRef = useRef(null);
  const expectedAnimalSrcRef = useRef('');
  const [displayAudio, setDisplayAudio] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [changeText, setChangeText] = useState('_________');
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [option3, setOption3] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const [tryAgain, setTryAgain] = useState(getVideo(`appfiles/eye_contact/andrea_try_again.mp3`, login));

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png')
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
  const correctSound = new Audio(generateImageUrl('media/Module1Videos/button_accept_item.mp3'));

  // Helper to request playing an animal voice, restarting if same src
  const playAnimalVoice = useCallback(async (src, restartIfSame = true) => {
    const el = animalAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedAnimalSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try {
        el.pause();
        el.currentTime = 0;
        await el.play();
      } catch (e) {
        const msg = String(e && e.message ? e.message : e);
        if (!msg.includes('interrupted by a new load request')) {
          // eslint-disable-next-line no-console
          console.log('animal audio replay failed', e);
        }
      }
    } else {
      setAnimalVoice(src);
    }
  }, []);

  useEffect(() => {
    setupGame();
  }, []);

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Sets up the game by selecting which possible answers to display in what order based on the current feeling.
  function setupGame() {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    };
    // Sets the crab video and audio thatt should play based on the emotion
    const number = 0;
    let numArray = [];
    numArray = [
      props.options[number].correctMatch,
      props.options[number].incorrectMatches[0],
      props.options[number].incorrectMatches[1],
    ];
    numArray = numArray
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);

    setKeyword(props.options[number].correctMatch.title);
    setChangeText(props.options[number].prompt);
    setIntroSound(getVideo(props.options[number].audioPrompt, login));
    setQuestion(true);
    setOption1(numArray[0]);
    setOption2(numArray[1]);
    setOption3(numArray[2]);
    setPractice(true);
  }

  // Finds out what the user selected, and uses that as the current answer.
  async function setAnswer(option, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(option);
    setAnimalVoice('');
    setAnimaTalk(false);
    setQuestion(false);
    await sleep(500);
    const src = getVideo(option.audioPrompt, login);
    await playAnimalVoice(src);
    setAnimaTalk(true);
    setDisplayAudio(true);
  }

  // The HTML code for the practice
  return (
    <>
      {practice && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceSituationHeader'>{props.title}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          {(
            <img
              className='greenCheckPractice12'
              style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
              src={greenCheck}
              alt=''
              onClick={() => {
                setAnimalVoice('');
                setAnimaTalk(false);
                if (keyword === answerkey.title) {
                  correctSound.play();
                  sleep(800).then(() => {
                    props.next();
                    props.setDisplayPractice(false);
                  });
                } else {
                  sleep(500).then(async () => {
                    await playAnimalVoice(tryAgain);
                    setAnimaTalk(true);
                    setDisplayAudio(true);
                    setAnswerkey(null);
                  });
                }
              }}
            />
          )}
          <br />
          <div className='gameGrid'>
            <div className='optionImage16' onClick={() => setAnswer(option1, 0)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option1.img} />
                {/* <h4 className='practiceText12'>{option1.title}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option2.img} />
                {/* <h4 className='practiceText12'>{option2.title}</h4> */}
              </div>
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option3, 2)}>
              <div className='set16'>
                <img alt='' className='crabExpression16' src={option3.img} />
                {/* <h4 className='practiceText12'>{option3.title}</h4> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {!animalTalk && question && (
        <audio autoPlay onEnded={() => setQuestion(false)}>
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <></>
      )}

      {/* Always-mounted audio for animalTalk */}
      <audio
        ref={animalAudioRef}
        src={animalVoice}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = animalAudioRef.current;
          if (!el) return;
          if (!displayAudio) return;
          const expected = expectedAnimalSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          el.currentTime = 0;
          el.play().catch((e) => {
            const msg = String(e && e.message ? e.message : e);
            if (!msg.includes('interrupted by a new load request')) {
              // eslint-disable-next-line no-console
              console.log('animal audio play failed', e);
            }
          });
        }}
        onEnded={() => {
          if (animalTalk) {
            setAnimaTalk(false);
          }
          setDisplayAudio(false);
        }}
      />

      {/* Kick playback if needed when displayAudio toggles */}
      {/* This is safe even if already playing */}
      {null}
    </>
  );
};
export default PracticeSituation;
